var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{attrs:{"fluid":""}},[_c('v-alert',{staticClass:"mx-auto mt-5",attrs:{"type":"error","max-width":"600","prominent":""}},[_c('h2',[_vm._v("404 Page not found")]),_vm._v(" The "+_vm._s(_vm.path)+" page was not found. ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }